import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import { Badge } from '../ui/badge';

const GaleriaPage = () => {
  const navigate = useNavigate();

  const eventos = [
    {
      id: 'bim-summit-2023',
      titulo: '2º BIM Summit Brasil',
      subtitulo: 'Belo Horizonte, MG - 2023',
      descricao: 'Palestra sobre Gêmeos Digitais e o futuro da digitalização na construção civil',
      fotos: [
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/zudp5azb_IMG_20231108_171059_822.jpg',
          alt: 'Alexander Justi - Palestrante'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/74lcewhc_IMG-20231021-WA0089.jpg',
          alt: 'Palestra sobre Gêmeos Digitais'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/1qs8qn50_IMG-20231021-WA0053.jpg',
          alt: 'Painel de Discussão'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/qdriw6je_IMG-20231021-WA0095.jpg',
          alt: 'Palestra BIM Academy'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/sm2muyen_IMG-20231021-WA0070.jpg',
          alt: 'Networking com palestrantes'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/8lrwknxi_IMG-20231021-WA0059.jpg',
          alt: 'Palestra ISO 19650'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/wsribe0k_IMG-20231021-WA0062.jpg',
          alt: 'Apresentação Instituto SENAI'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/tnztdtq2_IMG-20231021-WA0091.jpg',
          alt: 'Plateia assistindo palestra'
        }
      ],
      layout: 'grid-8'
    },
    {
      id: 'infracidades',
      titulo: 'Seminário InfraCidades',
      subtitulo: 'Governo do Estado do Rio de Janeiro - 2024',
      descricao: 'Palestra sobre Soluções baseadas no modelo CIM para cidades',
      fotos: [
        {
          src: 'https://customer-assets.emergentagent.com/job_d8423efd-c37a-42bb-b4a1-5cc382854da9/artifacts/oms10skp_IMG_20230901_114507_293.jpg',
          alt: 'Palestra Infracidades - Apresentação'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_d8423efd-c37a-42bb-b4a1-5cc382854da9/artifacts/ymlghfom_IMG_20230901_114717_457.jpg',
          alt: 'Palestra Infracidades - Palestrante'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_d8423efd-c37a-42bb-b4a1-5cc382854da9/artifacts/yffotkrx_IMG_20230902_155757_657.jpg',
          alt: 'Palestra Infracidades - Equipe'
        }
      ],
      layout: 'grid-3'
    },
    {
      id: 'bimday-pi',
      titulo: 'BIMDAY/PI',
      subtitulo: 'Teresina, PI - 2019',
      descricao: 'Evento sobre a disseminação do BIM na região Nordeste',
      fotos: [
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/b90v4n4q_IMG_20190824_083948_934%20%281%29.jpg',
          alt: 'Mesa de debates NBEC'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/s5mev00x_IMG_20190829_180810_577.jpg',
          alt: 'Palestra com auditório lotado'
        }
      ],
      layout: 'grid-2'
    },
    {
      id: 'bimday-df',
      titulo: 'BIMDAY/DF - O BIM Além do 3D',
      subtitulo: 'Brasília, DF - 2019',
      descricao: 'Evento organizado pela CBIM sobre a evolução do BIM na indústria da construção',
      fotos: [
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/gtfj50nd_IMG-20190816-WA0004.jpg',
          alt: 'Palestra CBIM'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/w9zh8bti_IMG-20190816-WA0008.jpg',
          alt: 'Alexander Justi palestrando'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/3r6h9x88_IMG-20190816-WA0010.jpg',
          alt: 'Mesa de abertura do evento'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/zd2xqd7g_IMG-20190816-WA0011.jpg',
          alt: 'Apresentação OrçaFascio'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/rwpeddp3_IMG-20190816-WA0013.jpg',
          alt: 'Auditório lotado'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/pkieni4t_IMG-20190816-WA0015.jpg',
          alt: 'Equipe organizadora'
        }
      ],
      layout: 'grid-6'
    },
    {
      id: 'sebim-se',
      titulo: '2º SeBIM-SE - Seminário BIM em Sergipe',
      subtitulo: 'Aracaju, SE - 2019',
      descricao: 'Seminário sobre a realidade do BIM em Sergipe, realizado no Hotel SESC Atalaia',
      fotos: [
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/1w58egid_IMG-20190831-WA0048.jpg',
          alt: 'Participantes do SeBIM-SE'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/z2fkrax8_IMG-20190901-WA0002.jpg',
          alt: 'Alexander Justi em entrevista'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/imyrqnls_IMG-20190901-WA0003.jpg',
          alt: 'Gravação de entrevista'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/c0lutp89_IMG-20190901-WA0004.jpg',
          alt: 'Auditório com participantes'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/3q5uphrr_IMG-20190902-WA0001.jpg',
          alt: 'Alexander Justi palestrando'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/8lvmenm9_IMG-20190831-WA0049.jpg',
          alt: 'Participantes no backdrop do evento'
        }
      ],
      layout: 'grid-6'
    },
    {
      id: 'cbim-rj',
      titulo: 'Encontro CBIM no CREA-RJ',
      subtitulo: 'Rio de Janeiro, RJ - 2019',
      descricao: 'Evento da Câmara Brasileira do BIM na sede do CREA-RJ',
      fotos: [
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/heddw3uc_IMG-20191001-WA0059.jpg',
          alt: 'Palestrantes na mesa'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/indxgwwl_IMG-20191001-WA0060.jpg',
          alt: 'Participantes do evento'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/c7xjfxx2_IMG-20191001-WA0065.jpg',
          alt: 'Alexander Justi na mesa de debates'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/9uxcr0m9_IMG-20191001-WA0069.jpg',
          alt: 'Equipe de palestrantes'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/jby856ia_IMG-20191001-WA0078.jpg',
          alt: 'Painel sobre competição Invent for The Planet'
        },
        {
          src: 'https://customer-assets.emergentagent.com/job_f459a428-de6b-4e68-81fa-96652542546d/artifacts/k9kjvx1h_IMG-20191001-WA0025.jpg',
          alt: 'Networking entre profissionais'
        }
      ],
      layout: 'grid-6'
    }
  ];

  return (
    <div className="min-h-screen bg-black">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-zinc-900 to-black">
        <div className="container mx-auto px-4 lg:px-8">
          <button
            onClick={() => navigate('/')}
            className="flex items-center text-gray-400 hover:text-white mb-8 transition-colors"
            data-testid="galeria-back-btn"
          >
            <ArrowLeft className="mr-2" size={20} />
            Voltar para Home
          </button>
          
          <div className="text-center">
            <Badge className="bg-yellow-600/20 text-yellow-400 border-yellow-500/30 mb-4">Memórias</Badge>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
              Galeria de <span className="text-yellow-500">Eventos</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Momentos marcantes da nossa participação em eventos e palestras pelo Brasil.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Content */}
      <section className="py-16 bg-black">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-6xl mx-auto space-y-16">
            {eventos.map((evento) => (
              <div 
                key={evento.id}
                className="bg-zinc-900/50 border border-zinc-800 rounded-xl overflow-hidden hover:border-yellow-500/30 transition-all duration-300"
                data-testid={`galeria-evento-${evento.id}`}
              >
                <div className="p-6 border-b border-zinc-800">
                  <h2 className="text-2xl md:text-3xl font-bold text-white">{evento.titulo}</h2>
                  <p className="text-yellow-500 font-medium text-lg">{evento.subtitulo}</p>
                  <p className="text-gray-400 mt-2">{evento.descricao}</p>
                </div>
                
                <div className={`grid ${
                  evento.layout === 'grid-8' ? 'grid-cols-2 md:grid-cols-4' : 
                  evento.layout === 'grid-6' ? 'grid-cols-2 md:grid-cols-3' :
                  evento.layout === 'grid-5' ? 'grid-cols-2 md:grid-cols-3' : 
                  evento.layout === 'grid-3' ? 'md:grid-cols-3' : 'md:grid-cols-2'
                } gap-4 p-6`}>
                  {evento.fotos.map((foto, index) => (
                    <div 
                      key={foto.src}
                      className={`group relative overflow-hidden rounded-lg ${
                        evento.layout === 'grid-8' ? 'aspect-square' :
                        evento.layout === 'grid-6' ? 'aspect-square' :
                        evento.layout === 'grid-5' && index === 0 ? 'col-span-2 md:col-span-1 aspect-square' :
                        evento.layout === 'grid-5' ? 'aspect-square' :
                        evento.layout === 'grid-3' ? 'aspect-square' : 'aspect-video'
                      }`}
                    >
                      <img 
                        src={foto.src}
                        alt={foto.alt}
                        className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                        <div className="absolute bottom-4 left-4 right-4">
                          <p className="text-white text-sm font-medium">{foto.alt}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GaleriaPage;
